import React, { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import CarCard from "../components/CarCard";
import AuctionTimer from "../components/AuctionTimer";
import BrandCard from "../components/BrandCard";
import TestimonialCard from "../components/TestimonialCard";
import HeroSlider from "../components/home/HeroSlider";
import NotifictionBar from "../components/home/NotifictionBar";
import SearchFilter from "../components/home/SearchFilter";
import api from "../lib/api.ts"; // adjust path
import { ValuesSection } from "../components/newabout/values-section.jsx";

import mb from "../assets/b4.jpg.png";
import audi from "../assets/au.png";
import F from "../assets/mb.png";
import BMW from "../assets/f.png";
import P from "../assets/p.png";
import fair from "../assets/fair.png";

import OurProcess from "../components/home/OurProcess";
import UpComingCarCard from "../components/UpComingCarCard";
import AuctionCarCard from "../components/AuctionCarCard";
import AuctionCarsList from "../components/AuctionCarsList";
import { useLanguage } from "../context/LanguageContext";
import { WhySellSection } from "../components/newsellerpage/why-sell-section.jsx";
// adjust the relative path depending on your folder structure
import PremiumBrandsHeader from "../components/PremiumBrandsHeader";
// import CountUp from "react-countup";
import UpcomingAuctionSection from "../components/home/UpcomingAuctionSection";
import translations from "../locals/translations.json";
// import { useInView } from "react-intersection-observer";
import { useRef } from "react";

import placeholder from "../assets/Car Image.png";
import ProcessSection from "../components/home/OurProcess";
// import Testimonials from "../components/Testimonials";
import Statistics from "../components/Statistics";
import FeaturedCars from "../components/FeaturedCars";
import AuctionComponent from "../components/AuctionComponent";

import { getPageSettings } from "../services/pagesettingServices.ts";
import BrandSection from "../components/BrandSection.jsx";
import LeftImage from "../components/LeftImage.jsx";
import QualitiesOfAction from "../components/QualitiesOfAction.jsx";
import Stats from "../components/Stats.jsx";
import TwoCars from "../components/TwoCars.jsx";
import { set } from "date-fns/set";
import usePageMeta from "../hooks/usePageMeta.js";

///new design components import here
import { Hero } from "../components/newhome/Hero.jsx";
import Auctions from "../components/newhome/auctions.jsx";
import { BuyerJourney } from "../components/newhome/buyer-journey.jsx";
import Testimonials from "../components/newhome/testimonials.jsx";
import LatestBlogs from "../components/newhome/LatestBlogs.jsx";
// import  Testimonials  from '../components/Testimonials.jsx'

const Home = () => {
  usePageMeta("homepage");

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  //---------------Brand------------
  const [brands, setBrands] = useState([]);
  const carouselRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  //  const [pageData, setPageData] = useState(null);
  const [pageData, setPageData] = useState({});

  const containerRef = useRef(null);
  const scroll = (direction) => {
    if (carouselRef.current) {
      const scrollAmount = 300; // Adjust this value as needed
      carouselRef.current.scrollBy({
        left: direction === "right" ? scrollAmount : -scrollAmount,
        behavior: "smooth",
      });
    }
  };
  const itemsToShow = window.innerWidth < 768 ? 2 : 5;

  // Sample data
  const auctionEndTime =
    new Date().getTime() +
    2 * 24 * 60 * 60 * 1000 +
    8 * 60 * 60 * 1000 +
    47 * 60 * 1000 +
    3 * 1000;

  const [qualities, setQualities] = useState([]);
  const [processSteps, setProcessSteps] = useState([]);
  const [stats, setStats] = useState([]);
  const [heroSection, setHeroSection] = useState([]);
  const [leftHeroSection, setLeftHeroSection] = useState([]);
  const [cars, setCars] = useState([]);
  const [auctions, setAuctions] = useState([]);
  const [auctionInfo, setAuctionInfo] = useState(null);
  const [testimonials, setTestimonials] = useState([]);
  const [whySellHeader, setWhySellHeader] = useState({});
  const [whySellBenefits, setWhySellBenefits] = useState([]);
  const [whySellCta, setWhySellCta] = useState({});
  const [buyerJourneyHeader, setBuyerJourneyHeader] = useState({});
  const [buyerJourneySteps, setBuyerJourneySteps] = useState([]);

  // -----------------------Translation-------------------
  const { language } = useLanguage();
  const isRTL = language === "ar";
  // -------------TOO Get Data ----------------------------
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await getPageSettings({
  //         page: "homepage",
  //         lang: language,
  //       });

  //       const qualityData = response.qualities_of_speed_auction || [];
  //       const processData = response.our_process || [];
  //       const animatedNumbers = response.animated_numbers || [];
  //       const heroSection = response.two_images_hero_section || [];
  //       const leftImageHero = response.left_image_hero_section || [];
  //       const testimonialsData = response.testimonials || [];

  //       // a("Testimonials Data:", testimonialData);

  //       const formattedQualities = qualityData.map((item) => ({
  //         title: item?.title?.value || "-",
  //         description: item?.description?.value || "-",
  //         icon: item?.imageUrl?.value || "-",
  //       }));

  //       const formattedProcess = processData.map((item, index) => ({
  //         // number: (index + 1).toString(),
  //         number: item?.number?.value || (index + 1).toString(),
  //         title: item?.title?.value || "-",
  //         description: item?.description?.value || "N/A ",
  //       }));
  //       const formattedHeroSection = heroSection.map((item) => ({
  //         title: item?.title.value || "-",
  //         description: item?.description?.value || "-",
  //         image: item?.imageUrl?.value,
  //         buttonText: item?.btnText?.value || "-",
  //         buttonLink: item?.btnLink?.value || "-",
  //       }));

  //       const formattedStats = animatedNumbers.map((item) => ({
  //         number: item?.NumberValue?.value || "-",
  //         label: item?.SubTitle?.value || "-",
  //       }));

  //       const formattedLeftHeroSection = leftImageHero.map((item) => ({
  //         title: item?.title?.value || "-",
  //         description: item?.description?.value || "-",
  //         image: item?.imageUrl?.value,
  //         buttonText: item?.btnText?.value || "-",
  //         buttonLink: item?.btnLink?.value || "#",
  //       }));

  //       console.log("+=============================+");
  //       console.log(testimonialsData);
  //       console.log("+=============================+");

  //       // const formattedTestimonials = Testimonials.map((item) => ({
  //       //   name: item?.name?.value || "-",
  //       //   description: item?.description?.value || "-",
  //       //   designation: item?.designation?.value || "-",
  //       //   date: item?.date?.value || "-",
  //       //   rating: item?.rating?.value || 0,
  //       // }));

  //       setQualities(formattedQualities);
  //       setProcessSteps(formattedProcess);
  //       setLeftHeroSection(formattedLeftHeroSection);

  //       setHeroSection(formattedHeroSection);
  //       setStats(formattedStats);
  //       setTestimonials(testimonialsData);
  //     } catch (err) {
  //       console.error("Fetch error:", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, []);

  // ...existing code...
  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await getPageSettings({
          page: "homepage",
          lang: language, // fetch per current language
        });

        const qualityData = response.qualities_of_speed_auction || [];
        const processData = response.our_process || [];
        const animatedNumbers = response.animated_numbers || [];
        const heroSection = response.two_images_hero_section || [];
        const leftImageHero = response.left_image_hero_section || [];
        const testimonialsData = response.testimonials || [];

        // Fetching new sections directly from homepage settings
        const whySellHeaderData = response.why_sell_header?.[0] || {};
        const whySellBenefitsData = response.why_sell_benefits || [];
        const whySellCtaData = response.seller_cta_section?.[0] || {};
        const buyerJourneyHeaderData = response.buyer_journey_header?.[0] || {};
        const buyerJourneyStepsData = response.buyer_journey || [];

        // Debug logging for language-specific data
        console.log("HOME FETCH - Language:", language);
        console.log("HOME FETCH - Why Sell Header:", whySellHeaderData);
        console.log("HOME FETCH - Why Sell Benefits:", whySellBenefitsData);
        console.log("HOME FETCH - Why Sell CTA:", whySellCtaData);

        if (cancelled) return;

        setWhySellHeader(whySellHeaderData);
        setWhySellBenefits(whySellBenefitsData);
        setWhySellCta(whySellCtaData);
        setBuyerJourneyHeader(buyerJourneyHeaderData);
        setBuyerJourneySteps(buyerJourneyStepsData);

        setQualities(
          qualityData.map((item) => ({
            title: item?.title?.value || "-",
            description: item?.description?.value || "-",
            icon: item?.imageUrl?.value || "-",
          })),
        );
        setProcessSteps(
          processData.map((item, index) => ({
            number: item?.number?.value || (index + 1).toString(),
            title: item?.title?.value || "-",
            description: item?.description?.value || "N/A ",
          })),
        );
        setHeroSection(
          heroSection.map((item) => ({
            title: item?.title?.value || "-",
            description: item?.description?.value || "-",
            image: item?.imageUrl?.value,
            buttonText: item?.btnText?.value || "-",
            buttonLink: item?.btnLink?.value || "-",
          })),
        );
        setStats(
          animatedNumbers.map((item) => ({
            number: item?.NumberValue?.value || "-",
            label: item?.SubTitle?.value || "-",
          })),
        );
        setLeftHeroSection(
          leftImageHero.map((item) => ({
            title: item?.title?.value || "-",
            description: item?.description?.value || "-",
            image: item?.imageUrl?.value,
            buttonText: item?.btnText?.value || "-",
            buttonLink: item?.btnLink?.value || "#",
          })),
        );

        setTestimonials(testimonialsData); // updates per language
      } catch (err) {
        console.error("Fetch error:", err);
        if (!cancelled) setError("Failed to load content");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchData();
    return () => {
      cancelled = true;
    };
  }, [language]);

  // Redundant fetchWhySellData removed as it's now handled in the main homepage settings fetch.

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        setLoading(true);
        const res = await api.get("/pagesettings/about-us", {
          params: { lang: language },
        });

        setPageData(res.data);
      } catch (err) {
        console.error("Failed to load About page data:", err);
        setError("Failed to load page content");
      } finally {
        setLoading(false);
      }
    };

    fetchAboutData();
  }, [language]);

  // ...existing code...
  useEffect(() => {
    const fetchAuctions = async () => {
      const response = await getPageSettings({
        page: "homepage",
        lang: language,
      });

      const auctionData = response.data?.data || [];

      if (auctionData.length > 0) {
        const firstAuction = auctionData[0];

        setAuctionInfo({
          name: firstAuction?.name || "",
          startDate: firstAuction?.startDate || "",
          laneName: firstAuction?.auctionLanes?.[0]?.lane?.name || "Lane A",
        });

        const cars = [];

        firstAuction.auctionLanes?.forEach((lane) => {
          lane.auctionLaneVehicles?.forEach((vehicleWrapper) => {
            const vehicle = vehicleWrapper.vehicle;

            cars.push({
              id: vehicle?.id || "",
              year: "", // not available
              make: vehicle?.MakeModel?.make?.name || "",
              model: vehicle?.MakeModel?.name || "",
              lotNo: vehicleWrapper?.id || "",
              startBid: vehicle?.startingBid || 0,
              currentBid: vehicle?.startingBid || 0,
              mileage: "", // not available
              engine: vehicle?.engine?.name || "",
              cylinders: vehicle?.cylinder?.name || "",
              condition: vehicle?.Highlight?.name || "Unknown",
              img: vehicle?.images?.[0]?.imageUrl || placeholder,
            });
          });
        });
      }
      setAuctions(cars);
    };

    fetchAuctions();
  }, []);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setCurrentIndex(0); // Reset index on resize
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  if (loading) return <div className="text-center py-8">Loading ...</div>;
  if (error)
    return <div className="text-center py-8 text-red-500">{error}</div>;

  // ------------------------------------------------

  return (
    <React.Fragment>
      <div className="">
        <Hero />

        <Auctions />
        <BuyerJourney header={buyerJourneyHeader} steps={buyerJourneySteps} />
        <WhySellSection
          header={whySellHeader}
          benefits={whySellBenefits}
          btntext={whySellCta?.primary_btn_text?.value}
          btnlink={whySellCta?.primary_btn_link?.value}
        />
        <Testimonials />
        <ValuesSection
          pillarsHeader={pageData?.core_pillars_header?.[0] || {}}
          pillars={pageData?.core_pillars || []}
        />
        <LatestBlogs />
        {/* <NotifictionBar /> */}
        {/* <HeroSlider />

        

        <BrandSection />
        <FeaturedCars /> */}
        {/* <LeftImage data={leftHeroSection} /> */}

        {/* <ProcessSection processData={processSteps} />
        <QualitiesOfAction qualityData={qualities} /> */}
        {/* ------------------------------------------- */}

        {/* Testimonials Section */}
        {/* <TwoCars heroSectionData={heroSection} />
        <Testimonials key={language} testimonialData={testimonials} />
        <Stats animated_numbers={stats} /> */}
        {/* <section className='max-w-7xl mx-auto bg-[#FEF8F6] my-5 py-10 rounded-xl  text-white'>
          <div className='px-4 sm:px-6 lg:px-8'>
            <div className='grid grid-cols-2 md:grid-cols-4 gap-8 text-center'>
              {stats.map((stat, index) => (
                <div key={index}>
                  <div className='text-[25px] md:text-[38px] font-bold text-[#050B20] mb-2'>
                    {stat.number}
                  </div>
                  <div className='text-[15px] font-normal text-[#050B20]'>
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section> */}
      </div>
    </React.Fragment>
  );
};

export default Home;
